<template>
  <basic-container>
    <el-form ref="searchForm" :model="query" label-width="100px" margin-top = "0" id="searchForm_iotDevice">
      <el-col :span="6">
        <el-form-item label="项目名称">
          <el-select
            v-model="query.projectId"
            placeholder="请选择项目名称"
            style="width: 100%"
            @change="projectSearchChange"
          >
            <el-option
              v-for="item in projectList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="仪表名称">
          <el-input v-model="query.meterName"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="仪表编号">
          <el-input v-model="query.meterNo"></el-input>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="仪表类型">
          <el-select
            v-model="query.meterType"
            placeholder="请选择仪表类型"
            style="width: 100%"
          >
            <el-option
              v-for="item in meterTypeList"
              :key="item.dictKey"
              :label="item.dictValue"
              :value="item.dictKey"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="4">
        <el-form-item label="设备卡号">
          <el-input v-model="query.cardNo"></el-input>
        </el-form-item>
      </el-col>

      <el-col :span="6">
        <el-form-item label="所属区域">
          <el-select
            v-model="query.areaId"
            placeholder="请选择存放区域"
            style="width: 100%"
            ref="connectSelect"
            name="connectSelect"
          >
            <el-option
              :value="query.areaId"
              show-all-levels
              :label="query.areaName"
            >
              <el-tree
                node-key="id"
                :data="treeFormAreaData"
                :props="treeProps"
                ref="areadTree"
                :load="searchAreaLazyLoadTree"
                lazy
                @node-click="searchAreaNodeTreeClick"
              >
              </el-tree>
            </el-option>
          </el-select>
        </el-form-item>
      </el-col>
      <el-col :span="6">
        <el-button icon="el-icon-search" size="small" type="primary" @click="search">
          搜索
        </el-button>
        <el-button icon="el-icon-delete" size="small" @click="searchReset">
          重置
        </el-button>
      </el-col>
    </el-form>
    <avue-crud :option="option"
               :table-loading="loading"
               :data="data"
               :permission="permissionList"
               :before-open="beforeOpen"
               v-model="form"
               ref="crud"
               @row-update="rowUpdate"
               @row-save="rowSave"
               @row-del="rowDel"
               @search-change="searchChange"
               @search-reset="searchReset"
               @selection-change="selectionChange"
               @current-change="currentChange"
               @refresh-change="onLoad"
               @on-load="onLoad"
               @tree-load="treeLoad"
               id="deviceIotCrud">

      <template slot="onlineFlag" slot-scope="scope">
        <el-tag :class="getClass(scope.row.onlineFlag)">{{
          scope.row.onlineFlag === 1 ? '在线' : '离线'
          }}</el-tag>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button type="text"
                   size="small"
                   icon="el-icon-plus"
                   plain
                   class="none-border"
                   @click.stop="addChildren(scope.row)">新增子级
        </el-button>
        <el-button type="text"
                   size="small"
                   icon="el-icon-finished"
                   plain
                   v-if="showEnabledBtn(scope.row)"
                   class="none-border"
                   @click.stop="enableDevice(scope.row.id)">启用
        </el-button>
        <el-button type="text"
                   size="small"
                   icon="el-icon-video-pause"
                   plain
                   class="none-border"
                   v-if="showDisabledBtn(scope.row)"
                   @click.stop="disableDevice(scope.row.id)">停用
        </el-button>
      </template>
    </avue-crud>
    <el-dialog
      id="iod_device_form"
      :title="operateName"
      :visible.sync="showOperateDialog"
      :modal-append-to-body="false"
      width="900px"
      @close="closeDialog"
    >
      <el-row v-if="showOperateDialog">
        <el-form ref="operateForm" :model="form" label-width="100px" margin-top = "0" id="operateForm_iotDevice" :rules="formRules">
          <el-col :span="8">
            <el-form-item label="项目名称" prop="projectId">
              <el-select
                v-model="form.projectId"
                placeholder="请选择项目名称"
                style="width: 100%"
                @change="projectSearchChange"
                disabled="true"
              >
                <el-option
                  v-for="item in projectList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仪表名称" prop="meterName">
              <el-input v-model="form.meterName" maxlength="32" :disabled="editDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仪表编号" prop="meterNo">
              <el-input v-model="form.meterNo" maxlength="50" :disabled="editDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仪表类型" prop="meterType">
              <el-select
                v-model="form.meterType"
                placeholder="请选择仪表类型"
                style="width: 100%"
                @change="meterTypeChange"
                :disabled="meterEditDisabled"
              >
                <el-option
                  v-for="item in meterTypeList"
                  :key="item.dictKey"
                  :label="item.dictValue"
                  :value="item.dictKey"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="仪表型号" prop="meterModelId">
              <el-select
                v-model="form.meterModelId"
                placeholder="请选择仪表型号"
                style="width: 100%"
                :disabled="editDisabled"
              >
                <el-option
                  v-for="item in meterModelList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="上级仪表">
              <el-select
                v-model="form.parentId"
                placeholder="请选择上级仪表"
                :disabled="meterEditDisabled"
                style="width: 100%"
              >
                <el-option
                  :value="form.parentId"
                  show-all-levels
                  :label="form.parentName"
                >
                  <el-tree
                    node-key="id"
                    :data="treeFormParentData"
                    :props="treeProps"
                    ref="areadTree"
                    :load="meterLazyLoadTree"
                    lazy
                    @node-click="meterNodeTreeClick"
                  >
                  </el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="所属区域" prop="areaId">
              <el-select
                v-model="form.areaId"
                placeholder="请选择存放区域"
                style="width: 100%"
                ref="connectSelect"
                name="connectSelect"
                :disabled="editDisabled"
              >
                <el-option
                  :value="form.areaId"
                  show-all-levels
                  :label="form.areaName"
                >
                  <el-tree
                    node-key="id"
                    :data="treeFormAreaData"
                    :props="treeProps"
                    ref="areadTree"
                    :load="searchAreaLazyLoadTree"
                    lazy
                    @node-click="formAreaNodeTreeClick"
                  >
                  </el-tree>
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="初始化时间" prop="initialTime">
              <el-date-picker
                type="datetime"
                v-model="form.initialTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 100%"
                :disabled="editDisabled"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="初始化表数" prop="initialNumber">
              <el-input v-model="form.initialNumber" type="number" min="0" max="999999999" :disabled="editDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="最大表数" prop="maxNumber">
              <el-input v-model="form.maxNumber" type="number" min="0" max="999999999" :disabled="editDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="权重" prop="sort">
              <el-input min="1" max="999999999" v-model="form.sort" type="number" :disabled="editDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="关联设备" prop="selectedDeviceList">
              <el-select
                v-model="selectedDeviceList"
                filterable placeholder="请选择关联设备"
                multiple
                :disabled="editDisabled"
                style="width:100%">
                <el-option
                  v-for="item in deviceList"
                  :key="item.id"
                  :label="item.deviceName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="设备卡号">
              <el-input v-model="form.cardNo" maxlength="30" :disabled="editDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="备注信息">
              <el-input type="textarea" rows="2" maxlength="200" v-model="form.remark" :disabled="editDisabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="6" offset="18">
            <el-button icon="el-icon-circle-check" type="primary" @click="saveData" v-if="!editDisabled">
              保存
            </el-button>
            <el-button icon="el-icon-circle-close" @click="closeDialog"  v-if="!editDisabled">
              取消
            </el-button>
          </el-col>
        </el-form>
      </el-row>
    </el-dialog>
  </basic-container>
</template>

<script>
  import {add, getChildren, getList, remove, update, meterLazyTree,updateStatus,getMeterModelList} from "@/views/v4ward/energy/device/api/deviceiot";
  import {getProjectDeviceList } from "@/api/crmedical/device/device";
  import {getProjectList} from "@/api/crmedical/project/project";
  import { lazyTree } from "@/api/crmedical/project/area";
  import { getDictionary } from "@/api/system/dict";
  import {mapGetters} from "vuex";

  export default {
    data() {
      //正整数验证yi
      var positiveIntegerCheck = (rule, value, callback) => {
        if ((typeof value !== 'number' && isNaN(value))) {
          callback(new Error('请输入数字！'));
        } else if( value <=  0 || value > 999999999) {
          callback(new Error('数字范围1-999999999！'));
        } else {
          var stringValue = value+'';
          if(stringValue.includes('.')){
            callback(new Error('请输入正整数！'));
          }else{
            callback();
          }
        }
      };
      //设备选择个数
      var checkSize =  (rule, value, callback) => {
        if(this.selectedDeviceList.length > 10){
          callback(new Error('关联设备个数不能超过10个！'));
        }else{
          callback();
        }
      };
      //大于0的2位小数验证
      var positiveFloatCheck =  (rule, value, callback) => {
        if ((typeof value !== 'number' && isNaN(value))) {
          callback(new Error('请输入数字！'));
        } else if( value < 0 || value > 99999999.9999) {
          callback(new Error('数字范围0-99999999.9999！'));
        } else {
          var stringValue = value + '';
          var valueArray = stringValue.split('.');
          if (stringValue.startsWith('0') && !stringValue.startsWith('0.') && stringValue.length > 1) {
            callback(new Error('数字范围0-99999999.9999！'));
          } else if (valueArray.length === 2 && valueArray[1].length > 4) {
            callback(new Error('最多4位有效数字!'));
          } else {
            callback();
          }
        }
      };

      return {
        form: {
          projectId: '',
          meterModelId: '',
          parentName: '',
          parentId: '',
          areaId: '',
          areaName: '',
          meterType: '',
        },
        query: {
          projectId: '',
          areaId: '',
          areaName:'',
          meterType: '',
        },
        loading: true,
        page: {
          pageSize: 10,
          currentPage: 1,
          total: 0
        },
        selectionList: [],
        option: {
          // height: 'auto',
          // calcHeight: 30,
          tip: false,
          searchShow: true,
          searchMenuSpan: 6,
          border: true,
          index: true,
          viewBtn: true,
          selection: false,
          dialogClickModal: false,
          indexLabel: '序号',
          align: 'center',
          tree: true,
          lazy: true,
          expandAll: false,
          expandLevel: 2,
          page: false,
          column: [
            {
              label: "仪表名称",
              prop: "meterName",
              width: 160,
              overHidden: true,
              align: 'left',
            },
            {
              label: "所属区域",
              prop: "areaName",
            },
            {
              label: "仪表类型",
              prop: "meterType",
              width: 70,
              type: 'select',
              //dataType: 'number',
              dicUrl: 'api/blade-system/dict/dictionary?code=meter_type',
              props: { label: 'dictValue', value: 'dictKey' },
            },
            {
              label: "仪表编号",
              prop: "meterNo",
            },
            {
              label: "设备卡号",
              prop: "cardNo",
            },
            {
              label: "上级仪表",
              prop: "parentName",
            },
            {
              label: "仪表型号",
              prop: "meterModelId",
              dicUrl: '/api/v4ward/iot/device/meterModelList',
              props: { label: 'name', value: 'id' },
            },
            {
              label: "初始化时间",
              prop: "initialTime",
              width: 130,
            },
            {
              label: "初始表数",
              prop: "initialNumber",
              width: 90,
            },
            {
              label: "最大表数",
              prop: "maxNumber",
              width: 90,
            },
            {
              label: "权重",
              prop: "sort",
              hide: true,
            },
            {
              label: "状态",
              prop: "status",
              width: 50,
              type: 'select',
              dicData: [{label: '启用',value: 1},{label: '停用',value: 0}]
            },
            {
              label: "运行状态",
              prop: "onlineFlag",
              slot: true,
              width: 70,
            },

          ]
        },
        data: [{}],
        treeProps: {
          //标题
          label: "name",
          //值
          value: "id",
          //子节点
          children: "zones",
          //是否叶子节点
          isLeaf: "hasChildren",
          //本节点类型key值
          objectType: "id",
          //本节点类型名
          objectTypeName: "name",
        },
        meterModelAllList: [],
        meterModelList: [],
        projectList: [],
        meterTypeList: [],
        areaList: [],
        treeFormAreaData: [],
        operateName: '新增',
        showOperateDialog: false,
        treeFormParentData: [],
        formRules: {
          projectId: [{required: true, message: "请选择项目名称", trigger: "change"}],
          meterName: [{required: true, message: "请输入仪表名称", trigger: "change"}],
          meterNo: [{required: true, message: "请输入仪表编号", trigger: "change"}],
          meterType: [{required: true, message: "请选择仪表类型", trigger: "change"}],
          meterModelId: [{required: true, message: "请选择仪表型号", trigger: "change"}],
          areaId: [{required: true, message: "请选择区域", trigger: "change"}],
          initialTime:[{required: true, message: "请选择初始化时间", trigger: "change"}],
          initialNumber: [{required: true, message: "请输入初始表数", trigger: "change"}, { validator: positiveFloatCheck, trigger: 'blur' }],
          maxNumber: [{required: true, message: "请输入最大表数", trigger: "change"},{ validator: positiveFloatCheck, trigger: 'blur' }],
          sort:  [{required: true, message: "请输入权重", trigger: "change"}, { validator: positiveIntegerCheck, trigger: 'blur' }],
          selectedDeviceList:  [{ validator: checkSize, trigger: 'change' }],
        },
        deviceList: [],
        selectedDeviceList:[],
        type: 'add',
        editDisabled: true,
        meterEditDisabled: true,
      };
    },
    watch: {
      'this.treeFormParentData'() {
        console.log(JSON.stringify(this.treeFormParentData));
      }
    },
    activated() {
      setTimeout(() => {
        this.$refs.crud.doLayout(); //解决表格错位
      }, 0);
    },
    computed: {
      ...mapGetters(["permission"]),
      permissionList() {
        return {
          addBtn: this.vaildData(this.permission.deviceiot_add, false),
          viewBtn: this.vaildData(this.permission.deviceiot_view, false),
          delBtn: this.vaildData(this.permission.deviceiot_delete, false),
          editBtn: this.vaildData(this.permission.deviceiot_edit, false)
        };
      },
      ids() {
        let ids = [];
        this.selectionList.forEach(ele => {
          ids.push(ele.id);
        });
        return ids.join(",");
      }
    },
    created(){
      getProjectList().then((data) => {
        this.projectList = data.data;
        if (this.projectList.length > 0) {
          this.query.projectId = this.projectList[0].id;
          this.initAreaList();
          this.onLoad();
        }
      });
      //加载列表
      getDictionary({code:'meter_type'}).then((res) => {
        this.meterTypeList = res.data.data;
        if(this.meterTypeList.length>0){
          this.query.meterType = this.meterTypeList[0].dictKey;
          this.onLoad();
        }
      });
      /*getDictionary({code:'meter_model'}).then((res) => {
        this.meterModelAllList = res.data.data;
      });*/
      getMeterModelList().then((res) => {
        this.meterModelAllList = res.data;
      })
    },
    methods: {
      showEnabledBtn(row){
        return this.vdui.isNotEmpty(row.cardNo) && row.status===0;
      },
      showDisabledBtn(row){
        return this.vdui.isNotEmpty(row.cardNo) && row.status===1;
      },
      enableDevice(id){
        this.$confirm("确定启用该设备?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return updateStatus({id: id,status:1});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      disableDevice(id){
        this.$confirm("确定停用该设备?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return updateStatus({id: id,status:0});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      getClass(onlineStatus) {
        if (onlineStatus === 1) {
          return 'tag-online';
        }else{
          return 'tag-offline'
        }
      },
      searchDeviceList(query){
        if(this.vdui.isEmpty(this.form.projectId)){
          return;
        }
        getProjectDeviceList({deviceName: query,projectId: this.form.projectId,size:50}).then(({data}) => {
          console.log(JSON.stringify(data));
          this.deviceList = data;
        }, error => {
          window.console.log(error);
        })
      },
      saveData() {
        if(this.vdui.isNotEmpty(this.form.cardNo)){
          this.form.cardNo = this.form.cardNo.trim().replace(' ','');
        }
        this.form.usedDeviceIds = this.selectedDeviceList.join(',');

        this.$refs.operateForm.validate((valid) => {
          if(valid){
            this.loading = true;
            add(this.form).then(() => {
              this.closeDialog();
              this.onLoad();
              this.$message.success('操作成功!');
            }, error => {
              this.loading = false;
              window.console.log(error);
            });
          }
        });
      },
      meterTypeChange(value){
        this.meterModelList = this.meterModelAllList.filter(model => {
          return model.meterType +'' === value +'' && model.status +'' === '1';
        });
        this.form.meterModelId = '';
        this.initMeterTreeData();
      },
      addChildren(row){
        this.beforeOpen(row,'child');
      },
      beforeOpen(done, type) {
        this.type=type;
        this.selectedDeviceList = [];
        if(type === 'add'){
          this.cleanForm();
          this.operateName = '新增';
          this.form.projectId = this.query.projectId;
          this.form.meterModelId = '';
          this.form.parentName = '';
          this.form.parentId = '';
          this.form.areaId = '';
          this.form.areaName = '';
          this.editDisabled = false;
          this.meterEditDisabled = false;
        }else if(type === 'child'){
          this.cleanForm();
          this.operateName = '新增';
          this.form.projectId = done.projectId;
          this.form.meterType = done.meterType;
          this.form.meterModelId = done.meterModelId;
          this.form.parentName = done.meterName;
          this.form.parentId = done.id;
          this.form.areaId = done.areaId;
          this.form.areaName = done.areaName;
          this.editDisabled = false;
          this.meterEditDisabled = true;
        }else if(type === 'edit'){
          this.operateName = '编辑';
          this.editDisabled = false;
          this.meterEditDisabled=false;
        }else {
          this.operateName = '查看';
          this.editDisabled = true;
          this.meterEditDisabled = true;
        }
        if (["edit", "view","child"].includes(type)) {
          /*getDetail({id:this.form.id}).then(({data}) => {
            this.form = data;
          });*/
          if(this.form.parentId === '0'){
            this.form.parentId = '';
          }
          if(this.vdui.isNotEmpty(this.form.usedDeviceIds)){
            this.selectedDeviceList = this.form.usedDeviceIds.split(',');
          }
        }
        this.initMeterModelList(this.form.meterModelId);

        if(this.deviceList.length === 0){
          getProjectDeviceList({projectId: this.form.projectId}).then(({data}) => {
            this.deviceList = data;
          }, error => {
            window.console.log(error);
          })
        }
        this.showOperateDialog = true;
        //done();
      },
      initMeterModelList(modelId){
        this.meterModelList = this.meterModelAllList.filter(model => {
          var status1 = model.meterType+'' === this.form.meterType +'' && model.status +'' === '1';
          var current = modelId === model.id;
          return status1 || current;
        });
      },
      initMeterTreeData(){
        meterLazyTree({ parentId: 0, projectId: this.form.projectId,meterType: this.form.meterType }).then(({ data }) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.hasChildren = !item.hasChildren;
            });
          }
          this.treeFormParentData = data;
        });
        this.form.parentId = '';
        this.form.parentName ='';
      },
      closeDialog(){
        this.showOperateDialog = false;
      },
      initAreaList(){
        lazyTree({ parentId: 0, projectId: this.query.projectId }).then(({ data }) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.hasChildren = !item.hasChildren;
            });
          }
          this.treeFormAreaData = data;
          this.query.areaName='';
          this.query.areaId='';
        });
      },
      meterNodeTreeClick(node){
        this.form.parentId = node.id;
        this.form.parentName = node.name;
      },
      meterLazyLoadTree(node,resolve) {
        let id ;
        if (node.level === 0) {
          id = 0;
        } else {
          id = node.data.id;
        }
        meterLazyTree({ parentId: id, projectId: this.query.projectId, meterType: this.query.meterType}).then(({ data }) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.hasChildren = !item.hasChildren;
            });
          }
          resolve(data);
        });
      },
      searchAreaNodeTreeClick(node){
        this.query.areaId = node.id;
        this.query.areaName = node.name;
      },
      formAreaNodeTreeClick(node){
        this.form.areaId = node.id;
        this.form.areaName = node.name;
      },
      searchAreaLazyLoadTree(node,resolve) {
        let id ;
        if (node.level === 0) {
          id = 0;
        } else {
          id = node.data.id;
        }
        lazyTree({ parentId: id, projectId: this.query.projectId }).then(({ data }) => {
          if (data instanceof Array) {
            data.forEach((item) => {
              item.hasChildren = !item.hasChildren;
            });
          }
          resolve(data);
        });
      },
      projectSearchChange(value){
        console.log(value);
        this.initAreaList();
        this.deviceList = [];
      },
      searchReset() {
        this.query = {
          projectId: '',
          areaId: '',
          areaName:'',
          meterType:'',
        };
        if(this.meterTypeList.length>0){
          this.query.meterType = this.meterTypeList[0].dictKey;
        }
        if (this.projectList.length > 0) {
          this.query.projectId = this.projectList[0].id;
          this.initAreaList();
        }
        this.page.currentPage = 1;
        this.onLoad();
      },
      search(){
        this.page.currentPage = 1;
        this.onLoad();
      },

      rowUpdate(row, index, done, loading) {
        update(row).then(() => {
          this.onLoad();
          this.$message.success('操作成功!');
          done();
        }, error => {
          window.console.log(error);
          loading();
        });
      },
      rowDel(row) {
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: row.id});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
          });
      },
      handleDelete() {
        if (this.selectionList.length === 0) {
          this.$message.warning("请选择至少一条数据");
          return;
        }
        this.$confirm("确定将选择数据删除?", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        })
          .then(() => {
            return remove({ids: this.ids});
          })
          .then(() => {
            this.onLoad();
            this.$message.success('操作成功!');
            this.$refs.crud.toggleSelection();
          });
      },
      cleanForm() {
        for (let key in this.form) {
          this.form[key] = null;
        }
      },

      searchChange(params, done) {
        this.query = params;
        this.page.currentPage = 1;
        this.onLoad();
        done();
      },
      selectionChange(list) {
        this.selectionList = list;
      },
      selectionClear() {
        this.selectionList = [];
        this.$refs.crud.toggleSelection();
      },
      currentChange(currentPage) {
        this.page.currentPage = currentPage;
      },
      sizeChange(pageSize) {
        this.page.pageSize = pageSize;
      },
      onLoad() {
        if(this.vdui.isEmpty(this.query.projectId) || this.vdui.isEmpty(this.query.meterType)){
          return;
        }
        this.loading = true;
        this.data =[];
        getList(this.query).then(({data}) => {
          this.data = data;
          this.loading = false;
          this.selectionClear();
        },error => {
          this.loading = false;
          console.log(error);
        });
      },
      /*      onLoad(page) {
        if(this.vdui.isEmpty(this.query.projectId)){
          return;
        }
        page = page || this.page;
        this.loading = true;
        getList(
          Object.assign({current: page.currentPage, size: page.pageSize}, this.query)
        ).then(({data}) => {
          this.page.total = data.total;
          this.data = data.records;
          this.loading = false;
          this.selectionClear();
        },error => {
          this.loading = false;
          console.log(error);
        });
      },*/
      treeLoad(tree, treeNode, resolve) {
        const parentId = tree.id;
        getChildren({parentId:parentId}).then(res => {
          this.$set(this.$refs.crud.$refs.table.store.states.lazyTreeNodeMap, parentId, []);
          resolve(res.data);
        });
      }
    }
  };
</script>
<style scoped>
  ::v-deep .el-dialog__body {
    padding: 0 40px;
  }
</style>

<style>
  #searchForm_iotDevice .el-input__inner{
    height: 32px;
  }
  #searchForm_iotDevice .el-button {
    margin-left: 30px;
    margin-top: 4px;
    height: 33px;
    width: 76px;
    padding: 8px 10px;
  }
  #searchForm_iotDevice .el-form-item {
    margin-bottom: 2px;
  }
  #operateForm_iotDevice .el-input__inner{
    height: 32px;
    padding-right: 2px;
  }
  #operateForm_iotDevice .el-form-item {
    margin-bottom: 6px;
  }
  #operateForm_iotDevice .el-button {
    margin-left: 20px;
    margin-top: 12px;
    margin-bottom: 32px;
    height: 33px;
    width: 76px;
    padding: 8px 10px;
    text-align: right;
  }
  #operateForm_iotDevice .el-form-item__error {
    padding-top: 0;
    padding-bottom: 4px;
  }

  .tag-offline {
    background-color: #fdffe0;
    color: red;
    font-weight: bold;
  }
  .tag-online {
    background-color: #f8ffff;
    color: #00d200;
    font-weight: bold;
  }
  #deviceIotCrud .el-tag {
    height: 28px;
    line-height: 27px;
  }
</style>
